import React, { useRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Header from "../layout/header";
import Footer from "../layout/footer";

export default function Paypal() {
  const paypal = useRef();
  const [userDetails, setUserDetails] = useState({});
  const history = useHistory();

  useEffect(async () => {
    const userDetails = await axios.get('/auth/userDetails');
    if (userDetails.firstName === 'Guest') {
      history.push('/')
    }
    setUserDetails(userDetails.data);
    
    // Create PayPal buttons for each offer
    const createPayPalButton = (description, value, creditsToAdd) => {
      return window.paypal.Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [{
              description: description,
              amount: {
                currency_code: "USD",
                value: value,
              },
            }],
          });
        },
        onApprove: async (data, actions) => {
          const userDetails = await axios.get('/auth/userDetails');
          const checkCredits = await axios.get(`/auth/getUserById/${userDetails.data._id}`);
          const updatedCredits = checkCredits.data.credits + creditsToAdd;
          await axios.post('/auth/changeCredits', {
            email: userDetails.data.email,
            amount: updatedCredits
          });
        },
        onError: (err) => {
          console.log(err);
        },
      });
    };

    // Render buttons for each offer
    createPayPalButton("10 positions of any kinds", 30.0, 10).render(paypal.current);
    createPayPalButton("25 positions of any kinds", 69.0, 25).render(paypal.current);
    createPayPalButton("36 positions of any kinds", 99.0, 36).render(paypal.current);
  }, []);

  return (
    <div className="paypal-container">
      <Header />
      
      <div className="paypal-content">
        <h1 className="paypal-title">Our Pricing</h1>
        <h3 className="paypal-welcome">
          Hello {userDetails.firstName}, welcome to our pricing page.
          <br />
          You can choose the plan that fits you the most and pay through PayPal.
          <br />
          Your credits will be updated as soon as your transaction is complete.
        </h3>
        
        <div className="pricing-cards">
          <div className="pricing-card">
            <h2 className="pricing-title">Basic Offer</h2>
            <p className="pricing-price">€30</p>
            <p className="pricing-positions">10 positions</p>
            
          </div>
          
          <div className="pricing-card featured">
            <h2 className="pricing-title">Gold Offer</h2>
            <p className="pricing-price">€69</p>
            <p className="pricing-positions">25 positions</p>
           
          </div>
          
          <div className="pricing-card">
            <h2 className="pricing-title">Platinum Offer</h2>
            <p className="pricing-price">€99</p>
            <p className="pricing-positions">36 positions</p>           
          </div>
          
        </div>
        <div className="paypal-button-container" ref={paypal}>
            </div>
      </div>
      
      <Footer />
      
      <style jsx>{`
        .paypal-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background-color: #f8f9fa;
        }
        
        .paypal-content {
          flex: 1;
          padding: 2rem;
          text-align: center;
          max-width: 1200px;
          margin: 0 auto;
          width: 100%;
        }
        
        .paypal-title {
          font-size: 2.5rem !important;
          color: #2c3e50;
          margin-bottom: 1.5rem;
        }
        
        .paypal-welcome {
        font-size:20px !important;
          color: #7f8c8d;
          margin-bottom: 3rem;
          line-height: 1.6;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .pricing-cards {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 2rem;
          margin-top: 2rem;
        }
        
        .pricing-card {
          background: white;
          border-radius: 10px;
          padding: 2rem;
          width: 300px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          position: relative;
        }
        
        .pricing-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        .pricing-card.featured {
          border: 2px solid #f1c40f;
        }
        
        .pricing-title {
          color: #2c3e50;
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }
        
        .pricing-price {
          font-size: 2rem;
          color: #3498db;
          margin-bottom: 0.5rem;
          font-weight: bold;
        }
        
        .pricing-positions {
          color: #7f8c8d;
          margin-bottom: 1.5rem;
        }
        
        .paypal-button-container {
          margin-top: 1rem;
          display: flex;
          justify-content: center;
        }
        
        @media (max-width: 768px) {
          .pricing-cards {
            flex-direction: column;
            align-items: center;
          }
          
          .paypal-title {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
}